import { render } from "./MyQuotation.vue?vue&type=template&id=5022e7c4"
import script from "./MyQuotation.vue?vue&type=script&lang=js"
export * from "./MyQuotation.vue?vue&type=script&lang=js"
script.render = render

export default script